import React from 'react'
import {plansData} from '../../data/plansData'
import "./Plans.css"
import whiteTick from '../../assets/whiteTick.png'
const Plans = () => {
  return (
    <div className='plans' id='Plans'>
      <div className="blur plan-blur"></div>
      <div className="blur plan-blur1"></div>
      <div className="plans-header">
        <span className='stroke-text'>Ready to Start </span>
        <span>Your Journey </span>
        <span className='stroke-text'>Now With Us</span>
      </div>
      <div className="plan-categories">
        {plansData.map((program)=>{
            {console.log("plans",program)}
            return (
            <div className="category-1">
                {program.icon}
                <span>{program.name}</span>
                <span>$ {program.price}</span>
                
                <div className="features">
                    {program.features.map((feature,i)=>(
                    
                    <div className='feature'> 
                        <img src={whiteTick} alt="" srcset="" />
                        <span key={i}>{feature}</span>
                    </div> 
                    ))}
                </div>
                <div><span>See More Benifits -></span></div>
                <button className='btn'>Join Now</button>
                {/* <div className="joinNow"><span>Join-Now</span></div>  */}
            </div>
            )
        })}
      </div>
    </div>  
  )
}

export default Plans
